import { t } from '@/utils/i18n'
import utils from './utils'
import { Toast } from 'antd-mobile'
import apis from '@/apis'
import router from '@/router'
import { routesMap } from '@/router/routes'
import storageUtil from '@/utils/localStorage'
import common from './common'

const { authApi } = apis
const { to } = utils
const { getLocalStorage, setLocalStorage } = storageUtil
const { handleCorpSetting } = common

interface IOptions {
  loopTime?: number
  store?: any
}

const BASE_LOOP_TIME = 3600 * 1 * 1000

/**
 * token大票续小票的相关逻辑
 */
class ExchangeToken {
  loopTime = BASE_LOOP_TIME
  timer: any = null
  loading = false
  constructor(options: IOptions = {}) {
    const { loopTime = BASE_LOOP_TIME } = options
    this.loopTime = loopTime
  }
  // 开始续票轮询
  startExchangeLoop() {
    const tempToken = sessionStorage.getItem('tempToken')
    // 如果已经有定时器或者有临时token，不轮询
    if (this.timer || tempToken) return

    this.timer = setInterval(() => {
      this.exchangeSmallToken()
    }, this.loopTime)
  }
  // 取消续票轮询
  cancelExchangeLoop() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }
  getExchangeRequestParams() {
    return getLocalStorage('exchangeRequestParams', true)
  }
  setExchangeRequestParams(data: {
    bigToken: string
    accountId: string
    id: string
    corpId: string
  }) {
    setLocalStorage('exchangeRequestParams', data)
  }
  setBigToken(token: string) {
    setLocalStorage('bigToken', token)
  }
  handleCorpSetting(setting: any) {
    const corpSetting = getLocalStorage('corpSetting', true) || {}
    const newCorpSetting = handleCorpSetting(setting)
    setLocalStorage('corpSetting', { ...corpSetting, ...newCorpSetting })
  }
  async exchangeSmallToken() {
    const params = this.getExchangeRequestParams()
    const tempToken = sessionStorage.getItem('tempToken')
    // 如果没有大票或者正在续票或者有临时token，不续票
    if (!params?.bigToken || this.loading || tempToken) return

    this.loading = true
    const [err, res] = await to(
      authApi.paifaExchangeTolen(params, { showMessage: false })
    )
    this.loading = false

    if (err || !res) {
      Toast.show(t('登录已过期，请重新登录'))
      this.cancelExchangeLoop()
      // 大票续票失败跳回登录页
      // router.navigate(routesMap.Login)
      common.logout()
      return
    }

    const resData = res.data || {}
    const smallToken = resData?.token || ''
    const setting = resData?.setting || {}

    // 把小票存到storage里
    setLocalStorage('token', smallToken)
    // 存储企业设置
    this.handleCorpSetting(setting)

    return smallToken
  }
}

export default new ExchangeToken()
